import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WebsiteDesign = () => {
  const [activeTab, setActiveTab] = useState('Design');

  const tabs = [
    { 
      id: 'Design', 
      title: 'Website Design', 
      desc: 'We craft unique brand identities that command attention. Our designs are engineered to convert visitors into loyal brand advocates through premium aesthetics.',
      media: { type: 'marquee', items: ["/assets/images/img3x2.webp", "/assets/images/img3x3.webp", "/assets/images/img3x4.webp"] }
    },
    { 
      id: 'Development', 
      title: 'Clean Code Scalability', 
      desc: 'High-performance development using the latest tech stack. We ensure your digital home is as sturdy as it is beautiful, optimized for lightning speed.',
      media: { type: 'code', content: 'const App = () => {\n  return <AxeSell premium="true" />\n}' }
    },
    { 
      id: 'Marketing', 
      title: 'Strategic Growth', 
      desc: 'Digital marketing that speaks to your audience. We use data-driven strategies to amplify your brand voice and reach the right customers.',
      media: { type: 'video', src: '/assets/images/video3x3.mp4' }
    },
    { 
      id: 'Management', 
      title: 'System Ecosystem', 
      desc: 'Take full control with our smart dashboards. From inventory to order tracking, manage your entire business operations from a single window.',
      media: { 
        type: 'features', 
        items: [
          { title: 'User Management', detail: ' Activate or deactivate profiles using user management features. Dashboard which will display all essential features to manage effectively.' },
          { title: 'Order Tracking', detail: ' Manage your cancelled, delivered, or exchanged orders. Track customer orders and make sure if the right orders are delivered.' },
          { title: 'Product Control', detail: 'Active/Inactive products can be managed effectively. Stock management, bulk product upload, updates, and additions.' }
        ] 
      }
    }
  ];

  const activeContent = tabs.find(tab => tab.id === activeTab);

  return (
    <div className="axs-premium-container">
      <nav className="axs-premium-nav">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`axs-nav-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.id}
            {activeTab === tab.id && (
              <motion.div layoutId="nav-bg" className="axs-active-bg" />
            )}
          </button>
        ))}
      </nav>

      <div className="axs-display-card">
        <AnimatePresence mode="wait">
          <motion.div 
            key={activeTab + 'text'}
            className="axs-text-side"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 30 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <h1>{activeContent.title}</h1>
            <p>{activeContent.desc}</p>
            {/* <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              style={{ background: 'var(--gradient-cta)', color: '#fff',     border:'none', padding: '15px 40px', borderRadius: '10px', fontWeight: '700', cursor: 'pointer'}}
            >
              Learn More
            </motion.button> */}
          </motion.div>
        </AnimatePresence>

        <AnimatePresence mode="wait">
          <motion.div 
            key={activeTab + 'media'}
            className="axs-media-side"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 1.1 }}
            transition={{ duration: 0.5 }}
          >
            {activeContent.media.type === 'marquee' && (
              <>
                <div className="axs-visual-marquee">
                  {[...activeContent.media.items, ...activeContent.media.items].map((img, i) => (
                    <img key={i} src={img} className="axs-mock-mobile" alt="UI View"    loading="lazy"/>
                  ))}
                </div>
                {/* <motion.div 
                  className="axs-floating-small-screen"
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.6 }}
                >
                  <img src="/assets/images/img27.png" alt="Small Screen View" className='custom-photo-web'   />
                </motion.div> */}
              </>
            )}

            {activeContent.media.type === 'code' && (
              <pre className="axs-visual-code">
                <code>{activeContent.media.content}</code>
              </pre>
            )}

            {activeContent.media.type === 'video' && (
              <video autoPlay muted loop playsInline style={{ width: '100%', height: '100%', objectFit: 'cover' }}>
                <source src={activeContent.media.src} type="video/mp4" />
              </video>
            )}

            {activeContent.media.type === 'features' && (
              <div className="axs-features-list">
                {activeContent.media.items.map((feat, i) => (
                  <motion.div 
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.1 }}
                    key={i} 
                    className="axs-feature-item"
                  >
                    <span className="axs-feature-title">{feat.title}</span>
                    <span className="axs-feature-desc">{feat.detail}</span>
                  </motion.div>
                ))}
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default WebsiteDesign;